module.exports = __webpack_public_path__ + "img/food-16.4bb9a931.jpg";